/* CATALOGUE · product gallery: one stage slide at a time, slim thumbnail strip, variant image sync.
   Tee carousel (cat-gallery[data-pp-car]): pixel arrows, swipe, arrow keys, counter, and a colour filter -
   slides tagged data-pp-col="white|black" are shown only for the selected Color; untagged slides (video, size chart, unmapped) always show. No deps. */
(function () {
  'use strict';
  if (customElements.get('cat-gallery')) return;
  class CatGallery extends HTMLElement {
    connectedCallback() {
      this.car = this.hasAttribute('data-pp-car');
      this.addEventListener('click', (e) => { const b = e.target.closest('.cp__thumb'); if (b) this.show(b.dataset.target, true); });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        if (this.car) {
          if (e.altKey || e.ctrlKey || e.metaKey) return;
          const th = e.target.closest('.cp__thumb');
          e.preventDefault(); this.step(e.key === 'ArrowRight' ? 1 : -1);
          if (th) { const t = this.querySelector('.cp__thumb[aria-current="true"]'); if (t) t.focus({ preventScroll: true }); }
          return;
        }
        if (!e.target.closest('.cp__thumb')) return;
        const t = [...this.querySelectorAll('.cp__thumb')], i = t.indexOf(e.target), n = t[(i + (e.key === 'ArrowRight' ? 1 : -1) + t.length) % t.length];
        e.preventDefault(); n.focus(); this.show(n.dataset.target);
      });
      if (this.car) this.initCarousel();
      if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const v = ev && ev.data && ev.data.variant; if (!v) return;
        if (this.car) { const c = this.variantColour(v); if (c && c !== this.col) this.setColour(c, v.featured_media && String(v.featured_media.id)); return; }
        if (v.featured_media) this.show(String(v.featured_media.id));
      });
    }
    /* ---- tee carousel ---- */
    initCarousel() {
      this.col = this.dataset.ppCur || '';
      this.cvals = (this.dataset.ppCvals || '').split(',').filter(Boolean);
      this.vmap = {}; (this.dataset.ppVmap || '').split(',').forEach((p) => { const i = p.indexOf(':'); if (i > 0) this.vmap[p.slice(0, i)] = p.slice(i + 1); });
      this.stage = this.querySelector('.cp__stage');
      this.querySelectorAll('.cp__slide').forEach((s) => { const li = this.querySelector('.cp__thumb[data-target="' + s.dataset.mid + '"]'); if (li) { const w = li.closest('li'); if (s.dataset.ppCol) w.dataset.ppCol = s.dataset.ppCol; } });
      const prev = this.querySelector('[data-pp-prev]'), next = this.querySelector('[data-pp-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));
      /* swipe: horizontal drag on the stage; the click that follows a swipe must not open the zoom viewer */
      let sx = 0, sy = 0, st = 0, id = null, swiped = false;
      const vp = this.querySelector('.cp__viewport') || this.stage;
      vp.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse' && e.button !== 0) return; if (e.target.closest('.cp__arrow, .pp-pin, pp-video button, pp-video a')) return; sx = e.clientX; sy = e.clientY; st = Date.now(); id = e.pointerId; swiped = false; });
      const end = (e) => {
        if (id === null || e.pointerId !== id) return; id = null;
        const dx = e.clientX - sx, dy = e.clientY - sy;
        if (e.pointerType !== 'mouse' && Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.4 && Date.now() - st < 900) { swiped = true; this.step(dx < 0 ? 1 : -1); }
      };
      vp.addEventListener('pointerup', end); vp.addEventListener('pointercancel', () => { id = null; });
      vp.addEventListener('click', (e) => { if (swiped) { swiped = false; e.stopPropagation(); e.preventDefault(); } }, true);
      /* colour option changed: react straight away (the section re-render follows) */
      document.addEventListener('change', (e) => {
        const t = e.target; if (!t || !t.name || !this.dataset.ppCname) return;
        if (String(t.name).trim() !== this.dataset.ppCname + '-' + this.dataset.ppCidx || !this.closest('product-info').contains(t)) return;
        const c = String(t.value || '').toLowerCase(); if (c && c !== this.col) this.setColour(c, this.vmap[c]);
      });
      this.refresh(); this.syncColour(false);
      if (this.col) { const a = this.querySelector('.cp__slide.is-active'); if (a) { const v = this.visible(); if (v[0] && v[0] !== a) this.setColour(this.col, a.dataset.mid, true); } }
    }
    variantColour(v) { const k = parseInt(this.dataset.ppCidx, 10); const o = k && (v['option' + k] || (v.options && v.options[k - 1])); return o ? String(o).toLowerCase() : ''; }
    off(s) { const c = s.dataset.ppCol; return !!(this.col && c && c !== this.col && this.cvals.indexOf(c) > -1); }
    syncColour() {
      this.querySelectorAll('.cp__slide').forEach((s) => { const o = this.off(s); s.toggleAttribute('data-pp-off', o); const w = this.querySelector('.cp__thumb[data-target="' + s.dataset.mid + '"]'); if (w) w.closest('li').hidden = o; });
    }
    /* PDP-COMPACT: colour change swaps to that colour's set, puts its featured (front) image first, resets to slide 1, crossfades 200 ms */
    setColour(c, preferId, quiet) {
      this.col = c; this.syncColour();
      let vis = this.visible();
      let t = preferId && vis.find((s) => s.dataset.mid === String(preferId));
      if (!t) t = vis.find((s) => s.dataset.ppCol === c && s.dataset.ppFace !== 'back');
      if (!t) t = vis[0];
      if (!t) return;
      const first = vis[0];
      if (first && first !== t) {
        first.parentNode.insertBefore(t, first);
        const th = this.querySelector('.cp__thumb[data-target="' + t.dataset.mid + '"]'), fth = this.querySelector('.cp__thumb[data-target="' + first.dataset.mid + '"]');
        if (th && fth) fth.closest('li').parentNode.insertBefore(th.closest('li'), fth.closest('li'));
      }
      const img = t.querySelector('img[loading="lazy"]'); if (img) img.loading = 'eager';
      this.show(t.dataset.mid);
      const strip = this.querySelector('.cp__thumbs'); if (strip) strip.scrollLeft = 0;
      if (!quiet && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && this.stage && this.stage.animate) this.stage.animate([{ opacity: 0.15 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
    }
    visible() { return [...this.querySelectorAll('.cp__slide')].filter((s) => !s.hasAttribute('data-pp-off')); }
    step(d) {
      const v = this.visible(); if (v.length < 2) return;
      let i = v.findIndex((s) => s.classList.contains('is-active')); if (i < 0) i = 0;
      this.show(v[(i + d + v.length) % v.length].dataset.mid);
    }
    refresh() {
      if (!this.car) return;
      const v = this.visible(), i = Math.max(0, v.findIndex((s) => s.classList.contains('is-active')));
      const multi = v.length > 1;
      this.querySelectorAll('.cp__arrow').forEach((b) => { b.hidden = !multi; });
      const c = this.querySelector('[data-pp-count]'); if (c) { c.hidden = !multi; c.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(v.length).padStart(2, '0'); }
    }
    show(id) {
      id = String(id);
      this.querySelectorAll('.cp__slide').forEach((s) => { const on = s.dataset.mid === id; s.hidden = !on; s.classList.toggle('is-active', on); });
      this.querySelectorAll('.cp__thumb').forEach((b) => b.setAttribute('aria-current', b.dataset.target === id ? 'true' : 'false'));
      if (this.car) {
        this.refresh();
        const b = this.querySelector('.cp__thumb[aria-current="true"]'), strip = b && b.closest('.cp__thumbs');
        if (strip) { const l = b.closest('li').offsetLeft - strip.offsetLeft, w = b.offsetWidth; if (l < strip.scrollLeft) strip.scrollLeft = l - 8; else if (l + w > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = l + w - strip.clientWidth + 8; }
      }
      window.dispatchEvent(new Event('scroll'));
    }
  }
  customElements.define('cat-gallery', CatGallery);
})();
/* "The physics" read more: full text stays in DOM; clamp ~4 lines with a white fade. */
(function () {
  function init() {
    document.querySelectorAll('[data-cp-clip]').forEach(function (c) {
      var b = c.nextElementSibling; if (!b || !b.classList.contains('cp-story__more')) return;
      if (c.scrollHeight <= c.clientHeight + 4) { c.classList.add('is-open'); return; }
      b.hidden = false;
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', String(open)); c.classList.toggle('is-open', open);
        b.textContent = open ? 'Read less' : 'Read more';
        if (!open) c.scrollIntoView({ block: 'nearest' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* B01A · front/back flip: [data-pp-flip] toggles between the front and the back print of the current colour.
   Back slides are tagged data-pp-face="back" (+ data-pp-fcol) in Liquid. Button hides when the current colour has no back.
   Key F (focus inside the gallery, no modifiers) does the same. Crossfade 180 ms; instant with prefers-reduced-motion. */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(g) {
    var b = g.querySelector('[data-pp-flip]'); if (!b || b.dataset.ready) return; b.dataset.ready = 1;
    var lab = b.querySelector('[data-pp-flip-label]'), lastFront = null;
    var slides = function () { return [].slice.call(g.querySelectorAll('.cp__slide')); };
    var col = function () { return g.col || ''; };
    var isBack = function (s) { return s && s.dataset.ppFace === 'back'; };
    var okCol = function (s) { var c = s.dataset.ppFcol || s.dataset.ppCol || ''; return !col() || !c || c === col(); };
    function backFor() { var bs = slides().filter(isBack); return bs.filter(okCol)[0] || (col() ? null : bs[0]); }
    function frontFor() {
      if (lastFront && !lastFront.hasAttribute('data-pp-off') && okCol(lastFront)) return lastFront;
      var vm = g.vmap && g.vmap[col()], s = vm && g.querySelector('.cp__slide[data-mid="' + vm + '"]');
      return s || slides().filter(function (x) { return !isBack(x) && !x.hasAttribute('data-pp-off') && !x.querySelector('pp-video'); })[0];
    }
    function sync() {
      var cur = g.querySelector('.cp__slide.is-active'), back = isBack(cur);
      if (!back && cur) lastFront = cur;
      b.hidden = !backFor();
      b.setAttribute('aria-pressed', back ? 'true' : 'false');
      lab.textContent = back ? b.dataset.lFront : b.dataset.lBack;
    }
    function flip() {
      var cur = g.querySelector('.cp__slide.is-active'), t = isBack(cur) ? frontFor() : backFor(); if (!t || t === cur) return;
      g.show(t.dataset.mid);
      if (!RM.matches && t.animate) t.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
    }
    /* warm the back print so the flip never shows an empty frame: on intent, and once the page is idle */
    function warm() { var t = backFor(), i = t && t.querySelector('img[loading="lazy"]'); if (i) i.loading = 'eager'; }
    ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) { b.addEventListener(ev, warm, { passive: true }); });
    window.addEventListener('load', function () { setTimeout(warm, 1500); });
    if (document.readyState === 'complete') setTimeout(warm, 1500);
    b.addEventListener('click', flip);
    g.addEventListener('keydown', function (e) {
      if ((e.key === 'f' || e.key === 'F') && !e.altKey && !e.ctrlKey && !e.metaKey && !/INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) { e.preventDefault(); flip(); b.focus({ preventScroll: true }); }
    });
    new MutationObserver(sync).observe(g, { subtree: true, attributes: true, attributeFilter: ['class', 'data-pp-off'] });
    sync();
  }
  function init() { document.querySelectorAll('cat-gallery').forEach(function (g) { customElements.whenDefined('cat-gallery').then(function () { setup(g); }); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.querySelectorAll('product-info').forEach(function (pi) { new MutationObserver(init).observe(pi, { childList: true, subtree: true }); });
})();
